import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";

import _ from "lodash";
import moment from "moment";
import { getImageDimensionSizes, getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { uploadFile } from "@/helpers/fileHelper";
import "@/EditDialog.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "KisCommitteeEditDialog",
  components: {
    LogOverview,
    EventImagePreview,
    ValidationDialog,
    TreeViewSelection
  },
  props: ["editDialog", "editedItem", "persons", "subjectAreas"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    manualSlug: false,
    step: 1,
    preventMainWatch: false,
    mainDragging: false,
    errorList: [],
    errorDialog: false
  }),
  mounted() {},
  methods: {
    close() {
      this.step = 1;
      this.manualSlug = false;
      this.$refs?.logOverview?.resetLogs();
      this.$emit("closeDialog");
    },
    addLeaderShip(value) {
      if (Array.isArray(value) && !value.length) {
        this.editedItem.leaderShip = null;
      } else {
        this.editedItem.leaderShip = value;
      }
    },
    addMember(value) {
      this.editedItem.member = value;
    },
    async save(close = false) {
      if (this.editedItem._id) {
        await this.updateCommittee();
      } else {
        await this.createCommittee();
      }

      const logsFetched = this.$refs?.logOverview?.logsFetched;
      this.$refs?.logOverview?.resetLogs();

      if (close) {
        this.close();
      } else if (logsFetched) {
        await this.$refs?.logOverview?.getLogs();
      }
    },
    async createCommittee() {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.post(
          `${env.kis_api_client_url}committee`,
          this.editedItem,
          {
            headers
          }
        );
        if (response.status === 201) {
          this.$emit("setCommittee", response.data);
          await this.$store.dispatch("createSuccess", "Erfolgreich erstellt");
          await this.$store.dispatch("getCommittees", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch(
          "createError",
          "Es ist ein Fehler aufgetreten!"
        );
      }
    },
    async updateCommittee() {
      try {
        await this.$emit("updateCommittee", this.editedItem);
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    userById(id) {
      if (!id) return "";
      const user = this.users.find(u => u.id === id || u._id === id);
      if (user?.first_name && user?.last_name)
        return `${user.first_name} ${user.last_name}`;
      else return null;
    },
    checkValid() {
      const form = this.$refs.committeeAreaEditForm;
      form.validate();
      const invalidFields = form._data.inputs.filter(i => !i.valid);
      this.errorList = [];
      invalidFields.forEach(field => {
        this.errorList.push({
          field: field?.$vnode?.componentOptions?.propsData?.label?.replace(
            "*",
            ""
          ),
          validations: field.validations
        });
      });
      if (this.errorList.length) this.errorDialog = true;

      if (this.errorList.length === 0) {
        return true;
      }
      return false;
    },
    async addDropFile(e, type, isImage = true) {
      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("bucket", "kis");

        const data = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "kis",
          this.currentPrincipal,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );
        if (!data?.image_sizes && data.url && isImage) {
          data.image_sizes = await getImageDimensionSizes(data.url);
        }
        data.principal_id = this.currentPrincipal;

        data.title = file.name;
        data.id = data._id;

        if (!this.editedItem.pictures) this.editedItem.pictures = [];
        this.editedItem.pictures.push(data);
        await this.save(false);
      });
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    readFileUrls(files, type) {
      this[`${type}Dragging`] = false;
      this[`${type}Files`].forEach(file => {
        if (!file.id) {
          const reader = new FileReader();
          reader.onload = event => {
            const target = event.target;
            if (target?.result) {
              file.originalUrl = target.result;
              file.dataUrl = target.result;
            }
          };
          reader.readAsDataURL(file);
        }
      });
    },
    async removeFile(id, type) {
      this.$emit("addToDestroyList", id);
      const index = this[`${type}Files`].findIndex(f => f.url.includes(id));
      this[`${type}Files`].splice(index, 1);
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    mainFiles: {
      get() {
        return this.editedItem?.pictures ?? [];
      },
      set(value) {
        this.editedEvent.pictures = value;
      }
    },
    users() {
      return this.$store.state.users;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.editedItem._id}`;
    }
  },
  watch: {
    mainFiles(val) {
      if (!this.preventMainWatch) {
        this.readFileUrls(val, "main");
      } else this.preventMainWatch = false;
    }
  }
};
